"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteLootShopItemResponseToJSON = exports.DeleteLootShopItemResponseFromJSONTyped = exports.DeleteLootShopItemResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function DeleteLootShopItemResponseFromJSON(json) {
    return DeleteLootShopItemResponseFromJSONTyped(json, false);
}
exports.DeleteLootShopItemResponseFromJSON = DeleteLootShopItemResponseFromJSON;
function DeleteLootShopItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.DeleteLootShopItemResponseFromJSONTyped = DeleteLootShopItemResponseFromJSONTyped;
function DeleteLootShopItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'message': value.message,
    };
}
exports.DeleteLootShopItemResponseToJSON = DeleteLootShopItemResponseToJSON;
